import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 31.023 7.506"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "var(--stroke-0, #4E80D6)",
  d: "M31.023 3.753 24.523 0v7.506l6.5-3.753ZM0 3.753v.65h25.173v-1.3H0v.65Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }